/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoadmapMilestoneMarkerDto } from './RoadmapMilestoneMarkerDto';
import {
    RoadmapMilestoneMarkerDtoFromJSON,
    RoadmapMilestoneMarkerDtoFromJSONTyped,
    RoadmapMilestoneMarkerDtoToJSON,
    RoadmapMilestoneMarkerDtoToJSONTyped,
} from './RoadmapMilestoneMarkerDto';
import type { RoadmapPlanSegmentDto } from './RoadmapPlanSegmentDto';
import {
    RoadmapPlanSegmentDtoFromJSON,
    RoadmapPlanSegmentDtoFromJSONTyped,
    RoadmapPlanSegmentDtoToJSON,
    RoadmapPlanSegmentDtoToJSONTyped,
} from './RoadmapPlanSegmentDto';

/**
 * 
 * @export
 * @interface RoadmapInitiativeRowDto
 */
export interface RoadmapInitiativeRowDto {
    /**
     * 
     * @type {string}
     * @memberof RoadmapInitiativeRowDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapInitiativeRowDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapInitiativeRowDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapInitiativeRowDto
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof RoadmapInitiativeRowDto
     */
    barStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoadmapInitiativeRowDto
     */
    barEnd?: Date;
    /**
     * 
     * @type {Array<RoadmapPlanSegmentDto>}
     * @memberof RoadmapInitiativeRowDto
     */
    plans?: Array<RoadmapPlanSegmentDto>;
    /**
     * 
     * @type {Array<RoadmapMilestoneMarkerDto>}
     * @memberof RoadmapInitiativeRowDto
     */
    milestones?: Array<RoadmapMilestoneMarkerDto>;
}

/**
 * Check if a given object implements the RoadmapInitiativeRowDto interface.
 */
export function instanceOfRoadmapInitiativeRowDto(value: object): value is RoadmapInitiativeRowDto {
    return true;
}

export function RoadmapInitiativeRowDtoFromJSON(json: any): RoadmapInitiativeRowDto {
    return RoadmapInitiativeRowDtoFromJSONTyped(json, false);
}

export function RoadmapInitiativeRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoadmapInitiativeRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'barStart': json['barStart'] == null ? undefined : (new Date(json['barStart'])),
        'barEnd': json['barEnd'] == null ? undefined : (new Date(json['barEnd'])),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(RoadmapPlanSegmentDtoFromJSON)),
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(RoadmapMilestoneMarkerDtoFromJSON)),
    };
}

export function RoadmapInitiativeRowDtoToJSON(json: any): RoadmapInitiativeRowDto {
    return RoadmapInitiativeRowDtoToJSONTyped(json, false);
}

export function RoadmapInitiativeRowDtoToJSONTyped(value?: RoadmapInitiativeRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'status': value['status'],
        'barStart': value['barStart'] == null ? undefined : ((value['barStart']).toISOString().substring(0,10)),
        'barEnd': value['barEnd'] == null ? undefined : ((value['barEnd']).toISOString().substring(0,10)),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(RoadmapPlanSegmentDtoToJSON)),
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(RoadmapMilestoneMarkerDtoToJSON)),
    };
}

